import { useState, useEffect } from 'react';

/**
 * Subscribe to a CSS media query and re-render on change.
 * @param {string} query e.g. '(max-width: 1023px)'
 * @returns {boolean} whether the query currently matches
 */
export function useMediaQuery(query) {
  const getMatch = () =>
    typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia(query).matches
      : false;

  const [matches, setMatches] = useState(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    // addEventListener is the modern API; addListener is the Safari<14 fallback.
    if (mql.addEventListener) mql.addEventListener('change', handler);
    else mql.addListener(handler);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', handler);
      else mql.removeListener(handler);
    };
  }, [query]);

  return matches;
}

/** True on phones and tablet-portrait (< 1024px) → compact layout. */
export function useIsMobile() {
  return useMediaQuery('(max-width: 1023px)');
}
